
import { IDriver } from "@interfaces/IDriver";
import { IJourney } from "@interfaces/IJourney";
import { IVehicle } from "@interfaces/IVehicle";
import { ChartService, ChartType } from "@services/charts.service";
import { DriverService } from "@services/driver.service";
import { GoogleService } from "@services/google.service";
import { JourneyService } from "@services/journey.service";
import { ITachoDay, TachoService } from "@services/tacho.service";
import { UnitConversionService, UnitConversionType } from "@services/unitConversion.service";
import { VehicleService } from "@services/vehicle.service";
import * as moment from "moment";
import "./drivers.scss";
import { IDriverScores } from "./driverScore.component";

export class DriversController {

    loading = false;

    drivers: IDriver[] = [];
    vehicles: IVehicle[] = [];

    selectedDriver: IDriver;
    fakeScore: IDriverScores;
    journeys: IJourney[];
    driverStaticMap: string;

    static $inject = ["chartService", "vehicleService", "driverService", "googleService", "journeyService", "tachoService", "unitConversionService"];

    constructor(
        private readonly chartService: ChartService,
        private readonly vehicleService: VehicleService,
        private readonly driverService: DriverService,
        private readonly googleService: GoogleService,
        private readonly journeyService: JourneyService,
        private readonly tachoService: TachoService,
        private readonly unitConversionService: UnitConversionService) {

        this.initialise();
    }

    selectDriver(driver: IDriver) {
        this.selectedDriver = driver;
        this.fakeScore = {
            overallScore: 67,

            harshBraking: 23,
            overAcceleration: 89,
            harshCornering: 3,
            overSpeeding: 12
        };

        // Generate google image based on.. something? Last known place?
        this.googleService.getMapUrl(new google.maps.LatLng(52.0709443, -0.7434205)).then(url => {
            this.driverStaticMap = url;
        });

        // Get historical day
        var start = moment().add(-31, "d");
        var end = moment();

        this.loading = true;
        this.journeyService.getJourneysForDriverSlim(this.selectedDriver.Id, start, end).then(journeys => {
            this.journeys = journeys;

            // Sort journeys
            this.journeys.sort((j1, j2) => {

                return j1.Id > j2.Id ? 1 : -1;
            });

            this.loading = false;

            this.journeys.forEach(journey => {
                journey.vehicle = this.vehicleService.findVehicle(this.vehicles, journey.VehicleId);
            });

            this.createPerformanceCharts(start, end);
        });
    }

    tachoDays: ITachoDay[];

    private initialise() {
        // Todo: Make parallel
        this.vehicleService.getVehicles({ includePeripheralMappings: true }).then(vehicles => {
            this.vehicles = vehicles;

            this.driverService.getDrivers().then(drivers => {
                this.drivers = drivers;

                this.drivers.forEach(driver => {
                    if (driver.Name == "Martin Box" || driver.Name == "THOMAS GOLDIE" || driver.Name == "NIGEL RICHARDS") {
                        this.selectDriver(driver);
                    }
                });
            });
        });
    }

    // ---

    performanceCharts: {
        title: string,
        config: Highcharts.Options
    }[] = [];

    private createPerformanceCharts(start: moment.Moment, end: moment.Moment) {
        this.performanceCharts = [];

        var mileageSeries: Highcharts.IndividualSeriesOptions[] = [
            {
                name: this.unitConversionService.getConversionLabel(UnitConversionType.Distance),
                data: [],
                id: "series1",
                type: "areaspline",
                zIndex: 2
            }
        ];

        var mileageChartConfig = this.createGenericDashboardChartConfig("line", mileageSeries);
        mileageChartConfig.plotOptions = {
            series: {}
        };

        mileageChartConfig.plotOptions.series["dataGrouping"] = {
            forced: true,
            units: [
                ['day', [1]]
            ]
        };

        this.chartService.setXAxisType(mileageChartConfig.xAxis, "datetime");

        // Process journeys by date
        mileageChartConfig.series[0].data = [];

        // Collate by day
        let dayMap = new Map<number, IJourney>()

        this.journeys.forEach((j, i) => {
            var day = moment(j.StartUtc).startOf("d").valueOf();

            // Try get existing journey aggregation
            if (!dayMap.has(day)) {
                dayMap.set(day, j);
                return;
            }

            var aggregatedJourney = dayMap.get(day);
            aggregatedJourney.DistanceKm += j.DistanceKm;
        });

        // first day
        var ticksInDay = 86400000;
        var firstDay = start.startOf("d").valueOf();
        var lastDay = end.startOf("d").valueOf();

        for (var day = firstDay; day <= lastDay; day += ticksInDay) {
            var j = dayMap.get(day);
            if (j) {
                mileageChartConfig.series[0].data[mileageChartConfig.series[0].data.length] = [day, Math.round(j.DistanceKm)];
            }
            else {
                mileageChartConfig.series[0].data[mileageChartConfig.series[0].data.length] = [day, 0];
            }
        }

        // We iterate through what we think
        //dayMap.forEach((j, day) => {
        //    mileageChartConfig.series[0].data[mileageChartConfig.series[0].data.length] = [day, Math.round(j.Distance)];
        //});

        //this.journeys.forEach((j, i) => {
        //    if (j.Distance == 0) {
        //        return;
        //    }

        //    mileageChartConfig.series[0].data[mileageChartConfig.series[0].data.length] = [moment(j.StartUtc).valueOf(), Math.round(j.Distance)];

        //    //console.log(mileageChartConfig.series[0].data[i], j);
        //});

        this.performanceCharts.push({ title: "Distance", config: mileageChartConfig })
    }

    private createGenericDashboardChartConfig(chartType: ChartType, series: Highcharts.IndividualSeriesOptions[]): Highcharts.Options {
        const $ctrl = this;

        var options = this.chartService.createBaseChartOptions(chartType);
        options.series = series;

        //this.chartService.setAxisLabelFormatter(options.yAxis, function () {
        //    // This removes the 0
        //    if (this.value) {
        //        return $ctrl.$filter("number")(this.value);
        //    }
        //    else {
        //        return "";
        //    }
        //})

        return options;
    }
}
